import React from 'react';
import { CheckCircle2, XCircle, Send } from 'lucide-react';

const short = (a) => `${a.slice(0, 8)}...${a.slice(-6)}`;

export function TakeoverAgentCard({ id, title, name, address, result, onSend }) {
  const bad = id === 'impostor';
  return (
    <div className={`rounded-xl border p-4 ${bad ? 'border-red-500/30' : 'border-white/10'} bg-black/30`} data-testid={`takeover-${id}-card`}>
      <div className="text-sm font-semibold text-white">{title}</div>
      <div className="text-xs text-gray-400 mt-1">Says it is <span className="font-mono">{name}</span></div>
      <div className="text-xs text-gray-400">Signs with key <span className="font-mono">{short(address)}</span></div>
      <button type="button" onClick={onSend} className={`mt-3 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${bad ? 'bg-red-300 text-black hover:bg-red-200' : 'bg-amber-300 text-black hover:bg-amber-200'}`} data-testid={`takeover-${id}-send-btn`}>
        <Send className="w-4 h-4" /> Send a cancellation
      </button>
      {result && (
        <div className={`mt-3 flex gap-2 text-sm ${result.ok ? 'text-emerald-100/90' : 'text-red-100/90'}`} data-testid={`takeover-${id}-result`}>
          {result.ok ? <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" /> : <XCircle className="w-4 h-4 mt-0.5 shrink-0 text-red-400" />}
          <span>{result.ok
            ? `201 Accepted. The signature matches the key the person approved. The case is shown in the receipt and timeline below.`
            : `403 Refused. Signed by ${short(result.signer)}, which the person never approved. The name matches, the key does not. No case was opened.`}</span>
        </div>
      )}
    </div>
  );
}
